package one.healthium.life.presentation.navigation.home.compose

import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import ifaandroid.apps.life.composeapp.generated.resources.Res
import ifaandroid.apps.life.composeapp.generated.resources.ic_book_36
import ifaandroid.apps.life.composeapp.generated.resources.ic_chat_36
import ifaandroid.apps.life.composeapp.generated.resources.ic_clipboard_36
import ifaandroid.apps.life.composeapp.generated.resources.ic_user_36
import kotlinx.coroutines.launch
import one.healthium.life.presentation.navigation.home.HomeComponent
import one.healthium.ui.compose.components.AppNavigationBar
import one.healthium.ui.compose.components.AppNavigationBarItem
import one.healthium.ui.compose.components.LocalGlobalProgressIndicator
import org.jetbrains.compose.resources.painterResource

@Composable
internal fun BottomNavigation(
    component: HomeComponent,
) {
    val stack by component.stack.subscribeAsState()
    val activeComponent = stack.active.instance
    val scope = rememberCoroutineScope()
    val globalProgressIndicator = LocalGlobalProgressIndicator.current

    AppNavigationBar {
        // Today
        AppNavigationBarItem(
            modifier = Modifier.weight(1f).testTag("nav_today"),
            icon = {
                Icon(
                    painter = painterResource(Res.drawable.ic_book_36),
                    contentDescription = null,
                )
            },
            selected = activeComponent is HomeComponent.Child.TodayChild,
            onClick = component::onTodayTabClicked,
        )

        // Insights
        AppNavigationBarItem(
            modifier = Modifier.weight(1f).testTag("nav_insights"),
            icon = {
                Icon(
                    painter = painterResource(Res.drawable.ic_clipboard_36),
                    contentDescription = null,
                )
            },
            selected = activeComponent is HomeComponent.Child.InsightsChild,
            onClick = component::onInsightsTabClicked,
        )

        // Chat
        AppNavigationBarItem(
            modifier = Modifier.weight(1f).testTag("nav_chat"),
            icon = {
                Icon(
                    painter = painterResource(Res.drawable.ic_chat_36),
                    contentDescription = null,
                )
            },
            selected = activeComponent is HomeComponent.Child.ChatChild,
            onClick = {
                scope.launch {
                    globalProgressIndicator.value = true
                    component.onChatTabClicked()
                    globalProgressIndicator.value = false
                }
            },
        )

        // Profile
        AppNavigationBarItem(
            modifier = Modifier.weight(1f).testTag("nav_profile"),
            icon = {
                Icon(
                    painter = painterResource(Res.drawable.ic_user_36),
                    contentDescription = null,
                )
            },
            selected = activeComponent is HomeComponent.Child.ProfileChild,
            onClick = component::onProfileTabClicked,
        )
    }
}
